// _setRawItem :: EffectFn2 () String String Unit
export function _setRawItem(key, value) {
  localStorage.setItem(key, value);
}

// _getRawItem :: EffectFn3 () String (String -> Maybe String) (Maybe String) (Maybe String)
export function _getRawItem(key, Just, Nothing) {
  var value = localStorage.getItem(key);
  return value ? Just(value) : Nothing;
}

// _removeRawItem :: EffectFn1 () String Unit
export function _removeRawItem(key) {
  localStorage.removeItem(key);
}

// _nuke :: Effect Unit
export function _nuke() {
  localStorage.clear();
}
